import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as appStore from '@appstore/*';
import { Page } from '@models/*';
import * as overviewStore from '@overviewstore/*';
import { ToastService } from '../../core/services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class RasterLocGuard implements CanActivate {
  constructor(
    private toastService: ToastService,
    private store: Store<overviewStore.OverviewState | appStore.AppState>
  ) {}

  canActivate(_: ActivatedRouteSnapshot, __: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(appStore.getAppInitComplete).pipe(
      filter((isComplete) => isComplete),
      take(1),
      mergeMap(() =>
        zip(this.store.select(overviewStore.getSelectedDepotUnloadActions), this.store.select(appStore.getRouterState))
      ),
      take(1),
      map(
        ([
          actions,
          {
            state: {
              params: { tourId, stopId }
            }
          }
        ]) => {
          if (actions.length) {
            return true;
          } else {
            this.store.dispatch(new appStore.RouterNavigate({ path: [`/tour/${tourId}/stop/${stopId}`] }));
            this.toastService.generatePageRedirectToast(Page.RASTER_LOCATION);
            return false;
          }
        }
      )
    );
  }
}
